import React from "react";
import loadable from "@loadable/component";
import CenterSpinner from "../../common/centerSpinner";

function AsyncAssemblyAdminRank({ ...rest }) {
  const AsyncLoad = loadable(() => import("../admin/AssemblyAdminRank"));
  console.log("Loading", AsyncAssemblyAdminRank.name);
  return <AsyncLoad {...rest} fallback={<CenterSpinner />} />;
}

export default AsyncAssemblyAdminRank;
